/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function PageDuplicate({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#PageDuplicate_svg__a)"><path d="M11.5 1.1a.6.6 0 0 1-.6.6h-2a.6.6 0 0 1 0-1.2h2a.6.6 0 0 1 .6.6M15 3.7a.6.6 0 0 0 .6-.6v-1A1.6 1.6 0 0 0 14 .5h-.9a.6.6 0 0 0 0 1.2h.9c.221 0 .4.18.4.4v1a.6.6 0 0 0 .6.6M15 4.6a.6.6 0 0 1 .6.6v1.3a.6.6 0 1 1-1.2 0V5.2a.6.6 0 0 1 .6-.6M15.6 8.6a.6.6 0 1 0-1.2 0v1.3a.6.6 0 0 0 1.2 0zM6 8.4a.6.6 0 0 1 .6.6v1.4H8a.6.6 0 1 1 0 1.2H6.6V13a.6.6 0 1 1-1.2 0v-1.4H4a.6.6 0 1 1 0-1.2h1.4V9a.6.6 0 0 1 .6-.6" /><path fillRule="evenodd" d="M11.6 7.513V7.5q0-.023-.002-.044a2.1 2.1 0 0 0-.592-1.382L8.539 3.536A2.1 2.1 0 0 0 7.033 2.9H5.2v-.8c0-.22.18-.4.4-.4h.983a.6.6 0 0 0 0-1.2H5.6A1.6 1.6 0 0 0 4 2.1v.8H2.5A2.1 2.1 0 0 0 .4 5v8.5c0 1.16.94 2.1 2.1 2.1h7a2.1 2.1 0 0 0 1.902-1.208 1 1 0 0 0 .098.008h2.6a1.6 1.6 0 0 0 1.6-1.6V12a.6.6 0 1 0-1.2 0v.8a.4.4 0 0 1-.4.4h-2.5V7.513M1.6 5a.9.9 0 0 1 .9-.9h3.9v1.733A2.267 2.267 0 0 0 8.667 8.1H10.4v5.4a.9.9 0 0 1-.9.9h-7a.9.9 0 0 1-.9-.9zm6-.699a1 1 0 0 1 .078.072L10.135 6.9H8.667c-.59 0-1.067-.478-1.067-1.067z" clipRule="evenodd" /></g><defs><clipPath id="PageDuplicate_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;